define(["require", "exports", "three"], function (require, exports, THREE) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Brick extends THREE.Mesh {
        constructor(hue) {
            var geometry = new THREE.BoxGeometry(2, 1, 1, 1, 1, 1);
            var material = new THREE.MeshPhongMaterial({ color: 0xFFFFFF });
            super(geometry, material);
            material.color.setHSL(hue, 1, 0.5);
        }
    }
    exports.Brick = Brick;
});



//////////////////
// WEBPACK FOOTER
// ./src/Brick.ts
// module id = 1
// module chunks = 0